(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-article"]) return;
  try {
    

let indexButton = document.getElementById('index');

if (indexButton){
	indexButton.addEventListener('click', indexOpenClose);
}

function indexOpenClose(){
	let container = document.getElementById('index-container');
	let sign = document.getElementsByClassName('index-sign')[0];
	let indexInnerText = document.getElementsByClassName('index-sub-text')[0];

	container.classList.toggle('hidden')

	if (sign.innerText == '+ '){
		sign.innerText = '- ';
		indexInnerText.innerText = '(click to close)';
	} else{
		sign.innerText = '+ ';
		indexInnerText.innerText = '(click to open)'
	}
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-test"]) return;
  try {
    

let indexButton = document.getElementById('index');

if (indexButton){
	indexButton.addEventListener('click', indexOpenClose);
}

function indexOpenClose(){
	let container = document.getElementById('index-container');
	let sign = document.getElementsByClassName('index-sign')[0];
	let indexInnerText = document.getElementsByClassName('index-sub-text')[0];

	container.classList.toggle('hidden')

	if (sign.innerText == '+ '){
		sign.innerText = '- ';
		indexInnerText.innerText = '(click to close)';
	} else{
		sign.innerText = '+ ';
		indexInnerText.innerText = '(click to open)'
	}
}


  } catch(e) { console.error(e); }
})();
})();
